<template>
  <div class="card column grid-3-g grid-11-s grid-11-m justify-space">
    <div class="row">
      <div class="title grid-7">JOB {{job.id || job.id_job}}</div>
      <div class="grid-5">
        <Status
          :color="'green'"
          v-if="job.status_cliente"
        >{{job.status_cliente.replace('Doutor', 'Supporter')}}</Status>
      </div>
    </div>
    <div class="row">
      <div class="column grid-7">
        <span>Agendando Para</span>
        {{new Date(job.dh_agendamento_cliente).toLocaleString().substr(0,16)}}
      </div>
      <div class="column grid-5">
        <span>Cidade</span>
        {{job.estado ? job.cidade+'/'+job.estado: job.cidade}}
      </div>
    </div>
    <div class="row margin-top" v-if="job.id_doutor">
      <div class="column grid-7">
        <span>Supporter</span>
        {{job.nome_agregado_doutor || job.nome_doutor}}
      </div>
      <div class="column grid-5">
        <span>Celular</span>
        {{job.celular_doutor | phone}}
      </div>
    </div>
    <div class="row buttons">
      <div class="grid-7" v-if="map && !remote">
        <Button layout="white-m row align-center" @click="marker => map(marker)">
          <img src="../assets/img/google.svg" alt />
          <div>Ver local de atendimento</div>
        </Button>
      </div>
      <div class="grid-7" v-if="job.deslocamento_monitorado && remote">
        <Button layout="white-m row align-center" @click="map(job)">
          <img src="../assets/img/google.svg" alt />
          <div>Acompanhar atendimento</div>
        </Button>
      </div>
      <div :class="(map || job.ultima_coordenada_doutor) ? 'grid-5':'grid-12'" class="row">
        <router-link :to="'/cliente/job/'+(job.id || job.id_job)">
          <Button layout="white-green">MAIS DETALHES</Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Status from "@/components/CardStatus.vue";
import Button from "@/components/Button.vue";
export default {
  components: {
    Status,
    Button
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    map: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Function | Boolean,
      required: false
    },
    remote: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.card {
  background: $white;
  box-shadow: 0px 6px 16px #00000029;
  border-radius: 21px;
  color: $gray-1;
  padding: 25px;
  margin-right: 40px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 40px;
  max-height: 200px;

  @media (max-width: $small) {
    margin-right: 20px;
  }
  .title {
    color: $black;
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 23px;
  }
  span {
    color: $gray-6;
    font-weight: 300;
  }
  .margin-top {
    margin-top: 16px;
  }
  .buttons {
    margin-top: 25px;
    .button-white-m {
      width: 36px;
      height: 35px;
      padding: 0px 10px;
      overflow: hidden;

      div {
        width: 180px;
        display: block;
      }
      img {
        margin-top: -4px;
      }
      &:hover {
        width: 215px;
        img {
          margin-top: 0px;
        }
      }
    }
    .button-white-green {
      max-width: 140px;
    }
  }
}
</style>
